import {IMessageSender} from "../visualizers/UnrealSignalRVisualizer";

let stateIndex = 1;

export function newStateId() {
    return (stateIndex++).toString();
}

export class BaseUnrealController {
    constructor(private readonly messageSender: IMessageSender) {

    }


    sendMessage(body:unknown) {
        this.messageSender.sendMessage(body);
    }

}


class VideoController extends BaseUnrealController {

    constructor(private readonly sessionId:string, messageSender:IMessageSender) {
        super(messageSender);
    }
    async start(videoName:string, loop?: boolean) {
        const msg = {
            Id: this.sessionId,
            Command: "VideoPlay",
            Video: "./Movies/" + videoName
        } as any;

        if (loop) {
            msg.Loop = true;
        }
        await this.sendMessage(msg);
        return true;
    }

    async paused(paused:boolean) {
        const msg = {
            Id: this.sessionId,
            Command: "VideoSetPause",
            IsPaused: paused

        } as any;
        await this.sendMessage(msg);
        return true;
    }

    async seek(timeMillis:number, isRelative?: boolean) {
        const msg = {
            Id: this.sessionId,
            Command: "VideoSeek",
            TimeMillis: timeMillis,
        } as any;
        if (isRelative) {
            msg.IsRelative = isRelative;
        }
        await this.sendMessage(msg);
        return true;
    }
}



export default VideoController;